import { EPublisherSolutionModelSubType } from 'common/contracts';
import { IPermissions } from 'common/permissions.types';
import { ESideBarContext } from 'design-system/AcSidebar/types';
import { UserDetails } from 'pages/Login/Login.types';
import { permissionsUtil } from 'utils/permissionsUtil';

export const checkDefaultPageName = (
  context: ESideBarContext,
  permissions?: IPermissions,
  id?: string
): string => {
  if (context === ESideBarContext.PORTAL) {
    return 'settings/portal';
  }

  if (permissions && id) {
    return checkDefaultProjectPage(permissions, id);
  }

  return '';
};

export const checkDefaultProjectPage = (
  permissions: IPermissions,
  publisherId?: string,
  userDetails?: UserDetails | null
) => {
  if (!publisherId) {
    return 'statistics';
  }

  if (!userDetails) {
    return 'statistics';
  }

  const hasAnalyticsViewPermission = permissionsUtil.canAccessAnalytics(
    permissions,
    publisherId
  );

  const isSingleProject = userDetails.projects?.length === 1;
  const isPaymentLinkProject =
    userDetails.projects?.[0]?.projectSubType ===
    EPublisherSolutionModelSubType.PAYMENT_LINKS;

  if (isSingleProject && isPaymentLinkProject && permissionsUtil.canAccessSettings(permissions, publisherId || '')) {
    return 'settings';
  }

  if (hasAnalyticsViewPermission) {
    return 'statistics';
  }

  return 'bundles';
};
